import { createFileRoute } from '@tanstack/react-router';
import StubPage from '@/pages/StubPage.jsx';

function SettingsRoute() {
  return <StubPage name="settings" />;
}

export const Route = createFileRoute('/settings')({ component: SettingsRoute });
